'use strict';

/**
 *
 * @name: nownessApp.story
 *
 */

import StoryConfig from './story.config';
import StoryTagsDirective from './story-tags.directive';
import GeneralStorySliderDirective from './general-story-slider.directive';
import GeneralStoryTemplateDirective from './general-story-template.directive';

const StoryModule = angular
  .module('nownessApp.story', [])
  .config(StoryConfig)
  .directive('nsStoryTags', StoryTagsDirective)
  .directive('generalStorySlider', GeneralStorySliderDirective)
  .directive('generalStoryTemplate', GeneralStoryTemplateDirective);

export default StoryModule.name;



// WEBPACK FOOTER //
// ./app/pages/story/story.module.js